import { Building2, FileText, Plus } from 'lucide-react'
import type { Lease } from './types'

interface Props {
  screen: 'pick_lease' | 'pick_type'
  leases: Lease[]
  loading: boolean
  onLeasePicked: (lease: Lease) => void
  onNewTenancy: () => void
  onNavigate: (path: string) => void
}

export function PreWizard({ screen, leases, loading, onLeasePicked, onNewTenancy, onNavigate }: Props) {
  if (screen === 'pick_lease') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-start justify-center pt-16 px-4">
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm w-full max-w-2xl">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
            <h2 className="text-base font-semibold text-gray-900">Dine lejemål</h2>
            <button
              onClick={() => onNavigate('/lejemaal/opret')}
              className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700"
            >
              <Plus className="h-4 w-4" />
              Opret nyt lejemål
            </button>
          </div>
          {loading ? (
            <div className="px-6 py-8 text-sm text-gray-400">Henter lejemål…</div>
          ) : leases.length === 0 ? (
            <div className="px-6 py-8 text-sm text-gray-400">Ingen lejemål fundet.</div>
          ) : (
            <table className="w-full">
              <thead>
                <tr className="text-xs font-semibold text-gray-400 uppercase tracking-wide border-b border-gray-100">
                  <th className="px-6 py-3 text-left">Adresse</th>
                  <th className="px-6 py-3 text-right"></th>
                </tr>
              </thead>
              <tbody>
                {leases.map(lease => (
                  <tr key={lease.id} className="border-b border-gray-50 last:border-0 hover:bg-gray-50">
                    <td className="px-6 py-3 text-sm text-gray-800">
                      {lease.property_address
                        ? `${lease.property_address}, ${lease.unit_no}`
                        : lease.unit_no}
                    </td>
                    <td className="px-6 py-3 text-right">
                      <button
                        onClick={() => onLeasePicked(lease)}
                        className="text-sm font-medium text-blue-600 hover:text-blue-800"
                      >
                        Vælg lejemål ›
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-start justify-center pt-16 px-4">
      <div className="w-full max-w-xl">
        <h2 className="text-lg font-semibold text-gray-900 mb-6 text-center">
          Hvilken type lejeforhold vil du oprette?
        </h2>
        <div className="flex gap-4">
          <button
            onClick={onNewTenancy}
            className="flex-1 flex flex-col items-center gap-3 p-6 bg-white rounded-xl border-2 border-gray-200 hover:border-blue-400 transition-colors cursor-pointer"
          >
            <FileText className="h-8 w-8 text-blue-600" />
            <div className="text-sm font-semibold text-gray-900">Nyt lejeforhold</div>
            <div className="text-xs text-gray-500 text-center">Opret en ny lejekontrakt fra bunden</div>
          </button>
          <div className="flex-1 flex flex-col items-center gap-3 p-6 bg-white rounded-xl border-2 border-gray-100 cursor-not-allowed opacity-50 relative">
            <Building2 className="h-8 w-8 text-gray-400" />
            <div className="text-sm font-semibold text-gray-500">Eksisterende lejeforhold</div>
            <div className="text-xs text-gray-400 text-center">Tilknyt en eksisterende kontrakt</div>
            <span className="absolute top-3 right-3 text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">
              Kommer snart
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
